import React, { useRef, useState } from "react";
import "../../styles/ComponentsStyles/Universal/DatePicker.style.css";
import calenderIcon from "../../assets/Icons/Universal/Calender.svg";
import PropTypes from "prop-types";
const DatePicker = ({
  label,
  name,
  setFieldValue,
  value,
  placeholder,
  parentClassName,
}) => {
  const calenderRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(value || "");
  const openCalender = () => {
    if (calenderRef === null) return;
    calenderRef.current.showPicker?.();
    calenderRef.current.click();
  };

  return (
    <div className={`datePickerInputSection ${parentClassName}`}>
      <label htmlFor={label}>{label}</label>
      <div className="datePickerInputContainer">
        <input
          type="date"
          ref={calenderRef}
          style={{
            width: "0",
            height: "0",
            opacity: "0",
            position:"absolute"

          }}
          onChange={(e) => {
            setFieldValue(e.target.value);
            setSelectedDate(e.target.value);
          }}
          
        />

        <input
          type="text"
          name={name}
          value={selectedDate}
          className="datePickerInput"
          placeholder={placeholder}
          required
          readOnly
        />
        <button
          title="choose Date"
          className="calenderOpenBtn"
          type="button"
          onClick={openCalender}
        >
          <img src={calenderIcon} alt="" />
        </button>
      </div>
    </div>
  );
};

export default DatePicker;

DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};
